(function () {
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.menu-toggle');
    if (!toggle) return;

    var nav = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!nav) return;

    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    nav.classList.toggle('is-open', !isOpen);
  });
})();
